
// import StoryBlokComponent from '~/components/Storyblok/Component'
import breakpointMixin from '~/mixins/breakpoints'

export default {
  //   components: {
  //     StoryBlokComponent,
  //   },
  mixins: [breakpointMixin],
  props: {
    blok: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      texts: null,
      textTargets: null,
      rotator: null,
      lastWord: 'insert here',
      masterTl: null,
    }
  },
  computed: {
    containerStyles() {
      const styles = {}

      styles.padding = this.getBreakpointValue(this.blok.padding)
      styles.margin = this.getBreakpointValue(this.blok.margin)

      return styles
    },
    rotatorTextStyles() {
      return `
        ${this.blok.textStyles}
        `
    },
  },

  mounted() {
    this.$nextTick(() => {
      this.initAnimation()
    })
  },
  methods: {
    initAnimation() {
      this.$gsap.context(() => {
        this.texts = this.blok.rotator
          ?.replace(/\s+/g, ' ')
          .split(',')
          .map((text) => text.trim()) // last word should match the one in HTML

        this.$nextTick(() => {
          this.textTargets = this.$gsap.utils.toArray('.rotator-text')

          if (this.textTargets) {
            const dur = Number(this.blok.animationdDuration) || 1
            const hold = Number(this.blok.animationHold) || 2
            const fadeInPercent = Number(this.blok.fadeInPercent) ?? 150
            const fadeOutPercent = Number(this.blok.fadeOutPercent) ?? -150
            const scaleOut = Number(this.blok.scaleOut) || undefined
            const scaleIn = Number(this.blok.scaleIn) || undefined

            this.textTargets?.forEach((obj, i) => {
              const tl = this.$gsap.timeline({
                delay: dur * i + hold * i,
                repeat: -1,
                repeatDelay: (this.textTargets.length - 1) * (dur + hold) - dur,
                defaults: {
                  ease: 'none',
                  duration: dur,
                },
              })
              tl.from(obj, {
                yPercent: fadeInPercent,
                opacity: 0,
                scale: scaleIn,
              })
              tl.to(
                obj,
                {
                  yPercent: fadeOutPercent,
                  opacity: 0,
                  scale: scaleOut,
                },
                '+=' + hold
              )
            })
          }
        })
      }, this.$refs.container)
    },
  },
}
